import { useTranslation } from "react-i18next";
import { Select as AntdSelect, type SelectProps as AntdSelectProps } from "antd";

import type { AvE2EProps } from "../types";

type CustomSelectProps = AvE2EProps & Omit<AntdSelectProps, "children">;

function CustomSelect(props: CustomSelectProps) {
  const { options, testIdPrefix, ...restProps } = props;
  const { t } = useTranslation();
  let newOptions = options;

  if (Array.isArray(newOptions)) {
    newOptions = newOptions.map((c) => {
      return { ...c, "data-testid": `${testIdPrefix}-${c.value}-select-option` };
    });
  }

  // Common microcopy by dropdown type; a placeholder passed by the caller wins. Plain dropdowns get none.
  let commonPlaceholder: string | undefined;

  if (restProps.mode === "multiple") {
    commonPlaceholder = t("common.components.multiSelectPlaceholder");
  } else if (restProps.showSearch) {
    commonPlaceholder = t("common.domainShared.global_autoCompletePlaceholder");
  }

  return (
    <AntdSelect
      // @ts-expect-error - AntdSelect does not have a role of list by default, but for accessibility reasons we want to add it. This is safe to ignore because AntdSelect will pass this prop down to the underlying DOM element.
      role="listbox"
      maxTagCount={3} // Display at most 3 tags — intentional UI styling.
      size="middle"
      data-testid={`${testIdPrefix}-select`}
      {...restProps}
      placeholder={restProps.placeholder ?? commonPlaceholder}
      options={newOptions}
    />
  );
}

export const Select = Object.assign(CustomSelect, {
  Option: AntdSelect.Option,
});
